export enum FinderIndices {
    ARTICLES = 'articles',
    CONTRACTS = 'contracts',
    COURSE = 'courses',
    CUSTOMER_MAIL_TEMPLATES = 'customermailtemplates',
    DOCUMENT_TYPES = 'documenttypes',
    EMPLOYEES = 'employees',
    EMPLOYEE_CONTRACT_TEMPLATES = 'employeecontracttemplates',
    INSTITUTIONS = 'institutions',
    INVOICE_TEMPLATES = 'invoicetemplates',
    JOB_ADS = 'jobads',
    PARENTS = 'parents',
    RESPONSIBLES = 'responsibles',
    STUDENTS = 'students',
    SUBJECTS = 'subjects',
    TAGS = 'tags',
    WAREHOUSE_ORDERS = 'warehouseorders',
    ROLES = 'roles',
    ROOMS = 'rooms',
    WHATS_APP_MESSAGE_TEMPLATES = 'whatsappmessagetemplates',
}
